import { useId } from "react";

export const BRAND = {
  name: "QLens",
  company: "Aireido Tech Pvt Ltd",
  tagline: "Enterprise data intelligence",
};

/**
 * The QLens mark: a lens ring (the "Q") over stacked data layers, on a dark tile. Inline SVG so it stays
 * sharp at any size and needs no asset pipeline. public/favicon.svg is the same drawing.
 */
export function BrandMark({ size = 32, style, title = BRAND.name }) {
  const id = useId().replace(/:/g, "");
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      role="img"
      aria-label={title}
      style={{ display: "block", flexShrink: 0, ...style }}
    >
      <defs>
        <linearGradient id={id} x1="8" y1="6" x2="56" y2="58" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#FF6A4D" />
          <stop offset="1" stopColor="#E02A12" />
        </linearGradient>
      </defs>
      <rect width="64" height="64" rx="14" fill="#0E1E26" />
      <circle cx="30" cy="30" r="17" fill="none" stroke={`url(#${id})`} strokeWidth="7" />
      <path d="M30 21.5 40 27 30 32.5 20 27Z" fill="#fff" />
      <path d="M20 33.5 30 39l10-5.5" fill="none" stroke="#fff" strokeWidth="3" strokeLinejoin="round" strokeLinecap="round" opacity=".7" />
      <path d="M42 42 53 53" stroke={`url(#${id})`} strokeWidth="8" strokeLinecap="round" />
    </svg>
  );
}

/** Mark + "QLens" wordmark, with the company line underneath when `byline` is set. */
export function BrandLockup({ size = 28, byline = false }) {
  return (
    <span className="brand-lockup">
      <BrandMark size={size} />
      <span className="brand-text">
        <span className="brand-name">
          Q<b>Lens</b>
        </span>
        {byline && <span className="brand-by">by {BRAND.company}</span>}
      </span>
    </span>
  );
}

export default BrandMark;
